/**
 * Gift card number field: groups the digits in blocks of four while typing.
 *
 * Markup contract:
 *   <input name="GiftCardNr" x-data="giftCardField">
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('giftCardField', () => ({
        init() {
            this.$el.addEventListener('input', () => this.group());
        },

        group() {
            const digits = this.$el.value.replaceAll(' ', '');

            this.$el.value = digits.match(/.{1,4}/g)?.join(' ') ?? '';
        },
    }));
});
